export var SortType;

(function (SortType) {
  SortType["byTime"] = "byTime";
  SortType["byName"] = "byName";
})(SortType || (SortType = {}));

export var OrderType;

(function (OrderType) {
  OrderType["asc"] = "asc";
  OrderType["desc"] = "desc";
})(OrderType || (OrderType = {}));